import { z } from 'zod';
import { partySchema } from '../../common';
import { dateSchema } from '../../validation';

export const orderReviewStatusSchema = z.enum(['verified']);
export type OrderReviewStatus = z.infer<typeof orderReviewStatusSchema>;

export const orderReviewSchema = z.object({
  /**
   * the user who verified the order. Phase 7 (relations-v2): flipped to
   * a {@link partySchema} snapshot.
   */
  user: partySchema,
  /** the status of the review (currently only 'verified') */
  status: orderReviewStatusSchema,
  /** the date when the order was verified */
  verifiedDate: dateSchema,
});
export type OrderReview = z.infer<typeof orderReviewSchema>;
